<template>
	<div>
		<b-modal
			id="JobModal"
			hide-footer
			hide-header
			no-close-on-backdrop
			:centered="isLaptop"
			:modal-class="!isLaptop ? 'bottom-modal' : ''"
			v-model="showJobDetailsModal"
			@hidden="$emit('close-modal')"
		>
			<main>
				<header class="candash-modal-top px-3 py-2 job-details-head">
					<div class="w-50 candash-modal-head">
						{{
							interview && !"fromTicket" in interview
								? "Details"
								: "Job Details"
						}}
						<span v-if="interview.isReported" class="report-btn ml-2"
							>Reported</span
						>
					</div>

					<div class="d-flex justify-content-end pointer">
						<img
							@click="$emit('close-modal')"
							class="rotate-on-hover"
							src="@/assets/newdesign/dashboard/blueCross.svg"
							alt=""
						/>
					</div>
				</header>

				<section
					class="px-4 py-4"
					:style="
						interview.panelMeetingStatus != 0
							? 'height: calc(100vh - (255px + env(safe-area-inset-bottom)));max-height:600px;'
							: 'height: calc(100vh - (290px + env(safe-area-inset-bottom)));'
					"
					style="overflow: auto"
				>
					<section class="d-flex align-items-center justify-content-between">
						<section class="id-tag add-gap d-flex">
							<span class="blue-card-blue-text">ID:</span>
							<span class="blue-card-black-text">{{
								interview.interviewRequestID
							}}</span>
						</section>
						<div
							v-b-tooltip.hover.bottom="
								getAmountToolTip(level, interview.paymentStatus)
							"
							class="blue-card d-flex align-items-center add-gap"
							style="height: 22px"
						>
							<img :src="getRupeeImage(level, interview)" alt="" />

							<div class="profile-time">{{ interview.amount }}</div>
						</div>
					</section>
					<section
						v-if="interview.panelMeetingStatus == 0"
						class="id-tag add-gap d-flex mt-2"
					>
						<span class="blue-card-red-text fw-400">Cancelled By:</span>
						<span class="blue-card-red-text fw-600">
							{{
								interview.cancelledBy.user === "Panel"
									? interview.cancelledBy.name
									: "Others"
							}}
						</span>
					</section>
					<section
						v-if="interview.cancelledBy == 'Panel' && interview.remarks"
						class="mt-3"
					>
						<div class="head">Remarks:</div>
						<div class="subhead word-break mt-1">{{ interview.remarks }}</div>
					</section>

					<hr v-if="interview.panelMeetingStatus == 0" class="gray-border" />

					<section class="mt-3 d-flex w-100">
						<section class="b-avatar-style" style="width: 18%">
							<b-avatar
								v-if="interview.image"
								:src="interview.image"
							></b-avatar>
							<b-avatar v-else :text="getUserIcon(interview.name)"></b-avatar>
						</section>
						<section style="width: 80%">
							<div class="profile-head mt-2 mobml-10px">
								{{ formattedData(interview.name) }}
							</div>
							<div
								class="profile-mail d-flex justify-content-between mt-2 mobml-10px"
							>
								<div
									class="id-tag mt-2 profile-time d-flex align-items-center add-gap"
								>
									<img src="@/assets/img/panel-time.svg" alt="" />

									{{ getFormattedTime(interview) }}
								</div>
							</div>
						</section>
					</section>

					<section class="d-flex align-items-center add-gap mt-2 mob-aiu">
						<div class="head lh-unset">Skills:</div>
						<div class="subhead lh-unset">
							{{
								interview.candidateSkills &&
								interview.candidateSkills.length != 0
									? formattedArray(interview.candidateSkills).join(", ")
									: "-"
							}}
						</div>
					</section>

					<hr class="gray-border" />
					<div class="d-flex justify-content-between">
						<div class="d-flex mr-3 add-gap blue-text">Candidate Profile</div>
						<img
						    class="pointer"
						    :class="!interview.link && 'not-allowed opac-5'"
							src="@/assets/img/panel-right-arrow.svg"
							alt=""
							@click="!interview.link ? '' : goToProfile()"
						/>
					</div>
					<hr class="gray-border" />
					<div class="d-flex add-gap flex-column mb-3">
						<div class="head">Job Name</div>
						<div class="subhead">
							{{ formattedData(interview.jobName) }}
						</div>
					</div>
					<div class="d-flex add-gap flex-column mb-3">
						<div class="head">Job Type</div>
						<div class="subhead">
							{{ formattedData(interview.jobType) }}
						</div>
					</div>
					<div class="d-flex add-gap flex-column mb-3">
						<div class="head">Job Role</div>
						<div class="subhead">
							{{ formattedData(interview.role) }}
						</div>
					</div>
					<div class="d-flex add-gap flex-column mb-3">
						<div class="head">Job Description</div>
						<div class="subhead" v-html="interview.description"></div>
					</div>
					<div class="d-flex add-gap flex-column mb-3">
						<div class="head">Skills</div>
						<div class="subhead">
							{{ formattedArray(interview.skills).join(", ") }}
						</div>
					</div>
				</section>
			</main>
			<footer
				v-if="$route.name == 'Transaction' || $route.name == 'TransactionMob'"
				class="h-100px lap-ptb15px border-frlapfooter d-flex align-items-center justify-content-end mt-3 px-3 pb-4"
			>
				<b-button class="candash-cancelBtn pointer mr-3" @click="closeModal()"
					>Cancel</b-button
				>
				<b-button
					class="candash-addBtn pointer"
					v-if="!interview.isReported"
					@click="openReportModal = true"
					>Report</b-button
				>
			</footer>
			<footer
				v-if="
					interview.panelMeetingStatus != 0 &&
					$route.name != 'Transaction' &&
					!('fromTicket' in interview) &&
					$route.name != 'TransactionMob'
				"
				class="h-100px lap-ptb15px border-frlapfooter d-flex align-items-center justify-content-end pb-4 mt-3 px-3"
			>
				<b-button
					v-if="level != 2"
					class="candash-cancelBtn pointer mr-3"
					@click="
						level == 0
							? $emit('accept-reject', false)
							: level == 1 && interview.timeRemaining == 'ongoing'
							? goToFeedback()
							: $emit('accept-reject', 'cancel')
					"
					>{{
						level == 0
							? "Reject"
							: level == 1 && interview.timeRemaining == "ongoing"
							? "Give Feedback"
							: "Cancel Meeting"
					}}</b-button
				>
				<b-button
					class="candash-addBtn pointer"
					@click="
						level == 0
							? $emit('accept-reject', true)
							: level == 1
							? openMeetingLink(interview.meetingLink)
							: interview.status == 2
							? $emit('view-feedback')
							: goToFeedback()
					"
				>
					{{
						level == 0
							? "Accept"
							: level == 1
							? "Join Meeting"
							: interview.status == 2
							? "View Feedback"
							: "Give Feedback"
					}}
				</b-button>
				<!-- <template v-else-if="level == 1">
				<b-button class="candash-cancelBtn pointer mr-3" @click="$emit('accept-reject', 'cancel')">Cancel Meeting</b-button>
				<b-button class="candash-addBtn pointer"> Join Meeting </b-button>
				</template>
				<b-button v-else class="candash-addBtn pointer"> Give Feedback </b-button> -->
			</footer>
		</b-modal>
		<ReportModal
			v-if="openReportModal"
			:showModal="openReportModal"
			:reportIssue="reportIssue"
			:isTransaction="isTransaction"
			:interviewId="interview.interviewID"
			@closeReport="openReportModal = false"
			@updateReport="updateData()"
		/>
	</div>
</template>

<script>
import {
	formattedData,
	openMeetingLink,
	getRupeeImage,
	getFormattedTime,
	formattedArray,
	getUserIcon,
	getAmountToolTip,
} from "@/components/PanelDasboard/panelHelpers";
import ReportModal from "@/components/JobProgress/ReportIssueModal.vue";
import { mapGetters } from "vuex";

export default {
	name: "JobDetailsModal",
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	data() {
		return {
			isLaptop: true,
			openReportModal: false,
			reportIssue: {
				1: "Payment not received",
				2: "Incorrect payment amount",
				3: "Delayed payment",
				4: "Others ",
			},
		};
	},
	props: {
		showJobDetailsModal: Boolean,
		interview: Object,
		level: Number,
		isTransaction: {
			type: Boolean,
			default: false,
		},
	},
	components: { ReportModal },
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
	},
	methods: {
		updateData() {
			this.$emit("update");
			if (!this.interview?.isReported) {
				this.interview.isReported = true;
			}
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1028;
		},
		closeModal() {
			this.$emit("close-modal");
		},
		getAmountToolTip(level, status) {
			return getAmountToolTip(level, status);
		},
		getUserIcon(name) {
			return getUserIcon(name);
		},
		formattedArray(skills) {
			return formattedArray(skills);
		},
		getFormattedTime(interview) {
			return getFormattedTime(interview);
		},
		getRupeeImage(level, interview) {
			return getRupeeImage(level, interview);
		},
		openMeetingLink(link) {
			openMeetingLink(link);
		},
		formattedData(data) {
			return formattedData(data);
		},
		goToProfile() {
			window.open(this.interview.link);
		},
		goToFeedback() {
			let basicInfo = {
				name: this.interview.name,
				panelName: this.interview.emailID,
				formID: this.interview.interviewInfo.feedbackFormID,
				licenseKey: this.interview.licenseKey,
				interviewID: this.interview.interviewID,
			};
			this.$store.commit("candidateVUEX/setFeedbackData", basicInfo);
			this.$emit("gotofeedback");
		},
	},
};
</script>

<style scoped>
.profile-head {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	color: #3a3c40;
	line-height: 13px;
}

.profile-email {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	line-height: 13px;
	color: #3a3c40;
}

.profile-time {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 13px;
	color: #333333;
}

.b-avatar-style .b-avatar {
	width: 70px;
	height: 70px;
}

.head {
	font-family: "Montserrat";
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	line-height: 16px;
	color: #3a3c40;
}

.subhead {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	line-height: 17px;
	color: #3a3c40;
}

.blue-card {
	padding: 4px 10px;
	gap: 4px;
	background: #e9f0f5;
	border-radius: 20px;
	width: fit-content;
}

.blue-card-blue-text {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 11px;
	line-height: 13px;
	color: #20639b;
}

.blue-card-black-text {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 11px;
	line-height: 13px;
	color: #3a3c40;
}

.blue-text {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 16px;
	color: #20639b;
}
.job-details-head {
	height: 60px;
	align-items: center !important;
}

.gray-border {
	border: 1px solid #ced4da !important;
}
.border-frlapfooter {
	border-top: 1px solid #d7d7d7;
}

.report-btn {
	border-radius: 4px;
	background-color: #eb00021a;
	color: #eb0002;
	font-family: "Lato";
	font-weight: 500;
	font-size: 12px;
	padding: 5px;
}
@media (min-width: 1029px) {
	.lap-ptb15px {
		padding-top: 15px !important;
		padding-bottom: 15px !important;
	}
}
@media (max-width: 1028px) {
	.b-avatar-style .b-avatar {
		width: 85px;
		height: 60px;
	}
	.mobml-10px {
		margin-left: 10px !important;
	}
	.mob-aiu {
		align-items: unset !important;
	}
	.lh-unset {
		line-height: unset;
	}
	.h-100px {
		height: 60px;
	}
	.h-100px.pb-4 {
		padding-bottom: 0px !important;
	}
}
</style>
